import React from 'react';
import { Select } from '../../../../base-components/Select';
import { ExtraProps } from '../../../../base-components/Select';
import { Tariff } from '../../../../types/entities';
import { useMatchesLabel } from '../../hooks/useMatchesLabel';
import { useMultipleValue } from '../../hooks/useMultipleValue';

interface TariffOption {
    value: number;
    label: string;
    matches?: number;
}

export interface Props {
    instanceId: string;
    tariffs: Tariff[];
    value: Tariff[];
    onChange: (value: Tariff[]) => void;
    className?: string;
    appearance?: ExtraProps['appearance'];
    matches?: { [k: string]: number };
}

type TariffValue = Pick<Tariff, 'id'>;

/**
 * Селектор тарифа
 */
export const SelectTariff: React.FC<Props> = ({
    instanceId,
    tariffs,
    value,
    onChange,
    className,
    appearance,
    matches,
}) => {
    const [selectOptions, selectValue, handleChange] = useMultipleValue<
        Tariff,
        TariffValue,
        TariffOption
    >({
        options: tariffs,
        key: 'id',
        value,
        onChange,
        createOption: (tariff: Tariff): TariffOption => ({
            value: tariff.id,
            label: tariff.name || '',
            matches: matches?.[tariff.id] || 0,
        }),
    });

    const formatOptionLabel = useMatchesLabel<TariffOption>();

    return (
        <Select
            instanceId={instanceId}
            placeholder="Тариф"
            value={selectValue}
            onChange={handleChange}
            options={selectOptions}
            className={className}
            isMulti={true}
            isSearchable={false}
            isClearable={false}
            appearance={appearance}
            formatOptionLabel={formatOptionLabel}
        />
    );
};
